// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__F9kG6","layout_background":"layout_layout_background__k8mJE","layout_content":"layout_layout_content__W16wk"};